import React from 'react';
import { Delegate } from '../../Containers/Delegate/Delegate';

export const MultipleSelect = ({ container, item, check, available, selected, onSelect, onUnselect, onClose }) => {
    const Container = container;
    const Item = item;

    return (
        <Delegate.Click onAction={onClose}>
            <Container>
                {available.map((item, index) => {
                    let isItemChecked = false;
                    selected.forEach(select => {
                        if (select.value === item.value) isItemChecked = true;
                    });

                    const selectItem = onSelect.bind(this, item);
                    const unselectItem = onUnselect.bind(this, item);

                    return (
                        <Item
                            checkMark={check}
                            isChecked={isItemChecked}
                            onClick={isItemChecked ? unselectItem : selectItem}
                            key={index}
                        >
                            {item.title}
                        </Item>
                    );
                })}
            </Container>
        </Delegate.Click>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Components/MultipleSelect/index.js